export enum FinancialStatementTypes {
    CURRENT_BUSINESS_ASSESSMENT = 'CURRENT_BUSINESS_ASSESSMENT',
    ANNUAL_REPORT_LAST_FINANCIAL_YEAR = 'ANNUAL_REPORT_LAST_FINANCIAL_YEAR',
    ANNUAL_REPORT_SECOND_TO_LAST_FINANCIAL_YEAR = 'ANNUAL_REPORT_SECOND_TO_LAST_FINANCIAL_YEAR',
    PLANNING_DOCUMENTS = 'PLANNING_DOCUMENTS',
    OTHER_COMPANY_DOCUMENTS = 'OTHER_COMPANY_DOCUMENT',
}


